import "./case-study.css";
import AnimatedCounter from "../animated-counter";
import RenterCustomerExchange from "./../../assets/images/rentid-customer-exchange.png";
export function CaseStudy() {
  return (
    <section className="case-study">
      <div className="case-study__card">
        {/* Left column - Image */}
        <div className="case-study__media">
          <div className="case-study__image-frame">
            <img
              src={RenterCustomerExchange}
              alt="RentID Customer Exchange"
              className="case-study__image"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
        </div>

        {/* Right column - Content and stats */}
        <div className="case-study__content">
          <div>
            <h1 className="case-study__title">
              From First-Time Renter to Loyal Guest
            </h1>
            <p className="case-study__subtitle">
              Reduce losses, keep high-demand vehicles on the road, and earn the
              trust that turns renters into referrals.
            </p>
          </div>

          {/* Statistics */}
          <div className="case-study__stats">
            <div className="case-study__stat">
              <div className="case-study__stat-value">
                <AnimatedCounter end={400} duration={2000} suffix="+" />
              </div>
              <p className="case-study__stat-text">
                Up to 400+ data points analyzed per renter
              </p>
            </div>
            <div className="case-study__stat">
              <div className="case-study__stat-value">
                <AnimatedCounter end={5} duration={2000} />
              </div>
              <p className="case-study__stat-text">
                5 products to create custom workflows
              </p>
            </div>
            <div className="case-study__stat">
              <div className="case-study__stat-value">
                <AnimatedCounter
                  end={3}
                  duration={2000}
                  prefix="<"
                  suffix="s"
                />
              </div>
              <p className="case-study__stat-text">
                Valuable risk data delivered in seconds
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
